export const LOGIN_SUCCESS_EVENT = 'ydppt-login-success'

export const emitLoginSuccess = (detail: { source?: string } = {}) => {
  window.dispatchEvent(new CustomEvent(LOGIN_SUCCESS_EVENT, { detail }))
}
